/**
 * Идентификатор запроса для поддержки: уходит заголовком `X-Request-Id` и
 * показывается на экране ошибки. Короткий, только ASCII (заголовок) и читаемый
 * вслух — `7c1e-a904-b3f2`.
 */
export const createTraceId = (): string => {
  const hex = crypto.randomUUID().replace(/-/g, '')

  return `${hex.slice(0, 4)}-${hex.slice(4, 8)}-${hex.slice(8, 12)}`
}
